module.exports = __webpack_public_path__ + "9e186c74e2e3d964b3dc3f5690c80173.pdf";